
<div class="flex items-center mx-4 mb-2 mt-5">
  <!-- <img (click)="backClicked()" class="rounded-full w-6 h-6 bg-blue-500 cursor-pointer " src="assets/back-icon.svg"> -->
  <p class="text-2xl ml-5 font-semibold  bg-color-white">Welcome!</p>
</div>
<div class="customcode-container">
    <ul class="responsive-table">
      <li class="table-header" style="color: gray; font-size: 12px; width: 97%;">
        <div class="customcode-column">Code</div>
        <!-- <div class="customcode-column">Authentication</div>
        <div class="customcode-column">exclusion List</div> -->
        <div class="customcode-column">User Count</div>
        <div class="customcode-column">User Limit</div>
        <div class="customcode-column"></div>
      </li>
      <li *ngFor="let customCode of customCodes" class="table-row" >
        <div class="customcode-column">{{customCode.code}}</div>
        <div class="divider"></div>
        <!-- <div class="customcode-column"></div>
        <div class="customcode-column"></div> -->
        <div class="customcode-column">{{customCode.user_count}}</div>
        <div class="divider"></div>
        <div class="customcode-column">{{customCode.user_limit}}</div>
        <div class="divider"></div>
        <div class="customcode-icon">
            <mat-icon (click)="goToCustomCode(customCode.code)" style="height: 25px; width: 25px; border: 1px solid #E1E9FE; border-radius: 50%; cursor: pointer; color: #386AF6;">
                <span>chevron_right</span>
            </mat-icon> 
        </div>
      </li>
    </ul>
  </div>